const get = text => (text ? String(text).replace(/<[^>]+>/gm, '') : '');

export default {
  get
};
